import {
  ContextualPrefetchType,
  PolicyRoutesEnum,
  PrefetchContextEnum,
  PrefetchQueryFnEnum,
} from 'interfaces'

/**
 * Prewarm policies
 * @param {prefetch} prefetch - contextual prefetch function from useContextualPrefetch
 * @returns {void}
 */
export const prewarmPolicies = (
  prefetch: ({route, context, payload}: ContextualPrefetchType) => void,
): void => {
  prefetch({
    route: PolicyRoutesEnum.BASE,
    context: PrefetchContextEnum.MOUNT,
    payload: {
      [PrefetchQueryFnEnum.WARM_POLICY_CATEGORIES]: {
        policyName: 'Base Policy',
      },
    },
  })
}

/**
 * Prewarm users, cloud app, bypass
 * @param {prefetch} prefetch - contextual prefetch function from useContextualPrefetch
 * @returns {void}
 */
export const prewarmSelectedPolicy = (
  prefetch: ({route, context, payload}: ContextualPrefetchType) => void,
): void => {
  prefetch({
    route: PolicyRoutesEnum.POLICIES_CONTENT,
    context: PrefetchContextEnum.MOUNT,
    payload: {
      [PrefetchQueryFnEnum.WARM_POLICY_ASSIGNMENT]: {
        policyName: 'Base Policy',
      },
      [PrefetchQueryFnEnum.WARM_POLICY_CAC_APP]: {
        policyName: 'Base Policy',
      },
      [PrefetchQueryFnEnum.WARM_POLICY_BYPASS]: {
        policyName: 'Base Policy',
      },
    },
  })
}
